<template>
  <div class="bg-white p-3 el-table">
    <h3>Тип реестра</h3>
    <div class="row">
      <div class="col-12 col-lg-8 col-xl-5">
        <div class="scroll-gradient">
          <div v-loading.body="fetchProgress" class="card-table scroll-gradient__scroller">
            <table class="card-table card-table_border text-secondary">
              <tr v-for="(item, ind) in items" :key="item.id">
                <td class="card-table__index">{{ind + 1}}</td>
                <td class="card-table__description">{{item.name}}</td>
                <td class="card-table__actions">
                  <!--                <i class="el-icon-edit el-icon-hover pointer mr-3" @click="onEdit(item)"></i>-->
                  <i class="el-icon-delete el-icon-hover pointer" @click="openDeleteDialog(item)"></i>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <el-button type="primary" plain size="medium" icon="el-icon-plus"
                   :loading="fetchProgress || deleteProgress" @click="onCreate" class="mt-4">
          Добавить
        </el-button>
      </div>
    </div>

    <RegistryTypeCreateDialog v-if="showCreateDialog" :visible.sync="showCreateDialog" />
    <DeleteDialog v-if="showDeleteDialog" :visible.sync="showDeleteDialog" :progress="deleteProgress" @onDelete="onDelete"  />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import RegistryTypeCreateDialog from '@/components/directory/registryTypes/RegistryTypeCreateDialog';
import DeleteDialog from '@/components/dialogs/DeleteDialog';

export default {
  components: {
    RegistryTypeCreateDialog, DeleteDialog,
  },
  data: () => ({
    showCreateDialog: false,
    showDeleteDialog: false,
  }),
  created() {
    this.fetchItems();
  },
  computed: {
    ...mapGetters({
      items: 'registryTypes/items',
      item: 'registryTypes/item',
      actionProgress: 'registryTypes/actionProgress',
      fetchProgress: 'registryTypes/fetchProgress',
      deleteProgress: 'registryTypes/deleteProgress',
    }),
  },

  methods: {
    ...mapMutations({
      setItem: 'registryTypes/setItem',
    }),
    ...mapActions({
      fetchItems: 'registryTypes/fetchItems',
      deleteItem: 'registryTypes/deleteItem',
    }),

    onCreate() {
      this.showCreateDialog = true;
    },

    onEdit(item) {
      this.setItem(item);
      this.showCreateDialog = true;
    },

    openDeleteDialog(item) {
      this.setItem(item);
      this.showDeleteDialog = true;
    },
    onDelete() {
      this.deleteItem({ id: this.item.id })
        .then(() => {
          this.setItem(null);
          this.showDeleteDialog = false;
        })
        .catch(() => {});
    },
  },
  watch: {
    showDeleteDialog(newVal) {
      if (!newVal) this.setItem(null);
    },
  },
};
</script>
<style lang="scss" scoped>
.card-table {
  max-height: 400px;
  overflow: auto;
  &__index {
    width: 10%;
  }
  &__description {
    width: 70%;
  }
  &__actions {
    text-align: right;
    width: 20%;
  }
}

</style>
